import type { FC, ReactNode } from 'react'
import './styles.css'

export type SelectableVehicle = {
  vin: string
  model: string
  imageUrl?: string | null
}

type VehiclesGridProps = {
  children: ReactNode
}

type VehiclesGridItemProps = {
  vehicle: SelectableVehicle
  selectionId?: string
  isSelected: boolean
  onSelect: (selectionId: string) => void
  topLeftContent?: ReactNode
  topContent?: ReactNode
  children?: ReactNode
}

export const VehiclesGrid: FC<VehiclesGridProps> = ({ children }) => {
  return <div className="vehicles-grid-container">{children}</div>
}

export const VehiclesGridItem: FC<VehiclesGridItemProps> = ({
  vehicle,
  selectionId,
  isSelected,
  onSelect,
  topLeftContent,
  topContent,
  children,
}) => {
  const effectiveSelectionId = selectionId ?? vehicle.vin

  return (
    <button type="button" className="vehicle-item" onClick={() => onSelect(effectiveSelectionId)}>
      {topLeftContent ? (
        <div className="vehicle-item-accessories vehicle-item-accessories-top-left">
          {topLeftContent}
        </div>
      ) : null}

      <div
        className="vehicle-item-accessories vehicle-item-accessories-top-right"
        aria-hidden="true"
      >
        {isSelected ? <div className="filled-radio" /> : <div className="unfilled-radio" />}
      </div>

      <div className="vehicle-item-top-content">{topContent}</div>

      {vehicle.imageUrl ? (
        <img src={vehicle.imageUrl} alt={vehicle.model} className="vehicle-item-image" />
      ) : (
        <div className="vehicle-item-image vehicle-item-image-placeholder">No Image</div>
      )}

      <div className="vehicle-item-description">
        <h3 className="vehicle-item-title">{vehicle.model}</h3>
        <p className="vehicle-item-details">{vehicle.vin}</p>
        {children}
      </div>
    </button>
  )
}
